import { Button } from '@mui/material';
import './Input.css';

import * as React from 'react';
import VisuallyHiddenInput from '../../UploadInput';

type Props = Readonly<{
	'data-test-id'?: string;
	accept?: string;
	label: string;
	onChange: (files: FileList | null) => void;
}>;

export default function FileInput({
	accept,
	label,
	onChange,
	'data-test-id': dataTestId,
}: Props): JSX.Element {
	return (
		<Button component='label'>
			<div
				style={{
					color: '#111',
					fontSize: '16px',
					border: '1px solid #666',
					borderRadius: '4px',
					padding: '0 5px',
				}}
			>
				選擇檔案
			</div>
			<VisuallyHiddenInput
				type='file'
				name='thumbnail'
				accept={accept}
				onChange={(e) => onChange(e.target.files)}
			/>
		</Button>
	);
}
